import type { DrawingDocument } from '../model';
import { reconcileCallouts } from './callouts';

/** Oldest snapshots beyond this depth are dropped so history cannot grow without bound. */
export const MAX_HISTORY_ENTRIES = 100;

export interface DocumentHistory {
  readonly past: readonly DrawingDocument[];
  readonly present: DrawingDocument;
  readonly future: readonly DrawingDocument[];
}

export function createDocumentHistory(document: DrawingDocument): DocumentHistory {
  return { past: [], present: document, future: [] };
}

export function commitHistory(history: DocumentHistory, document: DrawingDocument): DocumentHistory {
  if (document === history.present) return history;
  const past = [...history.past, history.present];
  return {
    past: past.length > MAX_HISTORY_ENTRIES ? past.slice(past.length - MAX_HISTORY_ENTRIES) : past,
    present: reconcileCallouts(history.present, document),
    future: []
  };
}

export function undoHistory(history: DocumentHistory): DocumentHistory {
  const previous = history.past.at(-1);
  if (!previous) return history;
  return {
    past: history.past.slice(0, -1),
    present: previous,
    future: [history.present, ...history.future]
  };
}

export function redoHistory(history: DocumentHistory): DocumentHistory {
  const next = history.future[0];
  if (!next) return history;
  return {
    past: [...history.past, history.present],
    present: next,
    future: history.future.slice(1)
  };
}
